import { PlayCircle } from "lucide-react";
import oa from "../../img/oa_video.mp4";
import { useState } from "react";
import preview from "../../img/OA_logo.jpg";

export default function PlatformTourWidget() {
const [showVideo, setShowVideo] = useState(false);

return (
    <>
        {/* WIDGET */}

        <div
            className="
                fixed
                left-6
                top-1/2
                -translate-y-1/2
                z-40
                w-80
            "
        >
            <div
                className="
                    bg-white
                    rounded-2xl
                    border
                    border-slate-200
                    shadow-2xl
                    overflow-hidden
                "
            >
                {/* HEADER */}

                <div className="bg-slate-900 text-white px-4 py-3">
                    <h3 className="font-bold text-slate-200">
                        Platform Tour
                    </h3>

                    <p className="text-xs text-slate-300 mt-1">
                        Explore Orion Analytics
                    </p>
                </div>

                {/* CONTENT */}

                <div className="p-4">

                    <p
                        className="
                            text-sm
                            text-slate-600
                            leading-relaxed
                            mb-4
                        "
                    >
                        Discover advanced stock screening,
                        quantitative strategies,
                        portfolio analytics,
                        mutual fund research,
                        options analytics and more.
                    </p>

                    <div
                        className="
                            relative
                            cursor-pointer
                            group
                        "
                        onClick={() => setShowVideo(true)}
                    >
                        <img
                            src={preview}
                            alt="Platform Preview"
                            className="
                                w-full
                                rounded-xl
                                border
                                border-slate-200
                            "
                        />

                        <div
                            className="
                                absolute
                                inset-0
                                bg-black/40
                                rounded-xl
                                flex
                                items-center
                                justify-center
                            "
                        >
                            <PlayCircle
                                size={60}
                                className="text-white"
                            />
                        </div>
                    </div>

                    <button
                        onClick={() => setShowVideo(true)}
                        className="
                            mt-4
                            w-full
                            bg-blue-600
                            hover:bg-blue-700
                            text-white
                            py-3
                            rounded-xl
                            font-semibold
                            transition
                        "
                    >
                        Watch Platform Tour
                    </button>

                </div>
            </div>
        </div>

        {/* VIDEO MODAL */}

        {showVideo && (
            <div
                className="
                    fixed
                    inset-0
                    bg-black/80
                    z-[9999]
                    flex
                    items-center
                    justify-center
                    p-6
                "
                onClick={() => setShowVideo(false)}
            >
                <div
                    className="
                        relative
                        bg-black
                        rounded-2xl
                        overflow-hidden
                        w-full
                        max-w-6xl
                    "
                    onClick={(e) => e.stopPropagation()}
                >
                    <button
                        onClick={() => setShowVideo(false)}
                        className="
                            absolute
                            top-4
                            right-4
                            z-20
                            bg-red
                            rounded-full
                            w-10
                            h-10
                            font-bold
                            shadow-lg
                        "
                    >
                        X
                    </button>

                    <video
                        controls
                        autoPlay
                        className="
                            w-full
                            max-h-[85vh]
                        "
                    >
                        <source
                            src={oa}
                            type="video/mp4"
                        />
                    </video>
                </div>
            </div>
        )}
    </>
);
}